import React from 'react'
import { PILOT_TAGS, RESOURCEdb } from '@wellbeingxltd/fe-lib/constants'
import Assessment from 'containers/Onboarding/Screens/Assessment'
import Introduction from 'containers/Onboarding/Screens/Introduction'
import Privacy from 'containers/Onboarding/Screens/Privacy'
import Welcoming from 'containers/Onboarding/Screens/Welcoming'
import Final from 'containers/Onboarding/Screens/Final'
import Pillars from 'containers/Onboarding/Screens/Pillars'
import Goal from 'containers/Onboarding/Screens/Goal'
import Satisfaction from 'containers/Onboarding/Screens/Satisfaction'
import Demographics from 'containers/Onboarding/Screens/Demographics'

const { SLEEP, NUTRITION, EXERCISE, COMMUNITY, STRESS, OCCUPATION } = RESOURCEdb.PILLARS

export const PILLARS = [
    { id: 0, text: SLEEP },
    { id: 1, text: EXERCISE },
    { id: 2, text: NUTRITION },
    { id: 3, text: COMMUNITY },
    { id: 4, text: OCCUPATION },
    { id: 5, text: STRESS },
]

const QUESTIONS = {
    SLEEP: 'Are you getting enough sleep?',
    EXERCISE: `Do you feel like you're getting enough exercise?`,
    NUTRITION: "Do you feel like you're eating a healthy, balanced diet?",
    OCCUPATION: 'Do you feel you spend enough time doing meaningful activities, from hobbies to learning new skills?',
    STRESS: 'Do you feel like you manage stress well?',
    COMMUNITY: "Do you feel you help other people as much as you'd like to and have enough regular social connections?",
    SATISFACTION: 'Overall, how satisfied are you with your life nowadays?',
    POSITIVE: {
        default: 'Do you feel your employment is positively impacting your wellbeing?',
        [PILOT_TAGS.STUDENTS]: 'Do you feel the course you are studying positively impacts your wellbeing?',
        [PILOT_TAGS.ACCENTURE]: 'Do you feel there’s a senior person at work who genuinely cares about your wellbeing?',
        [PILOT_TAGS.LINKLATERS]: 'Do you feel your experience at Linklaters is positively impacting your wellbeing?',
    },
}
export const createOnboardingSteps = () => [
    {
        index: 0,
        name: <Welcoming />,
        welcomeText: `Welcome to the ${''} Wellbeing Hub powered by Betterspace. Here’s how we help.`,
        buttonText: 'Continue',
        disable: false,
    },
    {
        index: 1,
        name: <Privacy />,
        welcomeText: 'It’s important you understand how we keep your data private.',
        buttonText: 'Continue',
        disable: false,
    },

    {
        index: 2,
        name: <Introduction />,
        welcomeText: 'This is what Dr. Iain Jordan has to say about how we look after our wellbeing..',
        buttonText: 'Got It',
        disable: false,
    },
    {
        index: 3,
        name: '',
        welcomeText: 'To get you setup, we need to learn a little about you so that we can personalise what you see.',
        buttonText: 'Get Started',
        disable: false,
    },
    {
        index: 4,
        name: <Assessment />,
        welcomeText: 'How do you currently feel across these 6 wellbeing areas.',
        buttonText: 'Continue',
        disable: true,
    },
    {
        index: 5,
        name: <Pillars />,
        welcomeText: `We’d recommend having a specific wellbeing area of focus.

And from what you’ve told us, nutrition is an area you may want to explore. Is this the case or do you want to focus on something else?`,
        buttonText: 'Continue',
        disable: true,
    },
    {
        index: 6,
        name: <Goal />,
        welcomeText: `And what are you looking to improve around your Sleep?`,
        buttonText: 'Continue',
        disable: true,
    },
    {
        index: 7,
        name: <Demographics />,
        welcomeText: `Thanks - you can always change your area of focus later.\n

Now, please share a few details to help us provide better recommendations.`,
        buttonText: 'Continue',
        disable: true,
    },

    {
        index: 8,
        name: <Satisfaction />,
        welcomeText: `Great - nearly there! These  two questions relate to your work-life and general  wellbeing.\n

Remember, this information will never be shared on an individual basis.`,
        buttonText: 'Continue',
        disable: true,
    },
    {
        index: 9,
        name: <Final />,
        welcomeText: 'Thanks for that. Finally, what exactly can we help you with first?',
        buttonText: 'Continue',
        disable: true,
    },
]

export const createAssessmentList = pilotTag => [
    {
        question: { id: 0, text: QUESTIONS.SLEEP },
        answersLabel: [
            { value: 0, text: 'Not at all' },
            { value: 1, text: 'Not at all' },
            { value: 2, text: 'Not really' },
            { value: 3, text: 'Not really' },
            { value: 4, text: 'Below average' },
            { value: 5, text: 'So-so' },
            { value: 6, text: 'Above average' },
            { value: 7, text: 'Most of the time' },
            { value: 7, text: 'Most of the time' },
            { value: 9, text: 'Yes, definitely' },
            { value: 10, text: 'Yes, definitely' },
        ],
        label: SLEEP,
        colour: SLEEP,
    },
    {
        question: { id: 1, text: QUESTIONS.EXERCISE },
        answersLabel: [
            { value: 0, text: 'Not at all' },
            { value: 1, text: 'Not at all' },
            { value: 2, text: 'Not really' },
            { value: 3, text: 'Not really' },
            { value: 4, text: 'Below average' },
            { value: 5, text: 'So-so' },
            { value: 6, text: 'Above average' },
            { value: 7, text: 'Most of the time' },
            { value: 7, text: 'Most of the time' },
            { value: 9, text: 'Yes, definitely' },
            { value: 10, text: 'Yes, definitely' },
        ],
        label: EXERCISE,
        colour: EXERCISE,
    },

    {
        question: { id: 2, text: QUESTIONS.NUTRITION },
        answersLabel: [
            { value: 0, text: 'Not at all' },
            { value: 1, text: 'Not at all' },
            { value: 2, text: 'Not really' },
            { value: 3, text: 'Not really' },
            { value: 4, text: 'Below average' },
            { value: 5, text: 'So-so' },
            { value: 6, text: 'Above average' },
            { value: 7, text: 'Most of the time' },
            { value: 7, text: 'Most of the time' },
            { value: 9, text: 'Yes, definitely' },
            { value: 10, text: 'Yes, definitely' },
        ],
        label: NUTRITION,
        colour: NUTRITION,
    },

    {
        question: { id: 3, text: QUESTIONS.COMMUNITY },
        answersLabel: [
            { value: 0, text: 'Not at all' },
            { value: 1, text: 'Not at all' },
            { value: 2, text: 'Not really' },
            { value: 3, text: 'Not really' },
            { value: 4, text: 'Below average' },
            { value: 5, text: 'So-so' },
            { value: 6, text: 'Above average' },
            { value: 7, text: 'Most of the time' },
            { value: 7, text: 'Most of the time' },
            { value: 9, text: 'Yes, definitely' },
            { value: 10, text: 'Yes, definitely' },
        ],
        label: COMMUNITY,
        colour: COMMUNITY,
    },

    {
        question: { id: 4, text: QUESTIONS.OCCUPATION },
        answersLabel: [
            { value: 0, text: 'Not at all' },
            { value: 1, text: 'Not at all' },
            { value: 2, text: 'Not really' },
            { value: 3, text: 'Not really' },
            { value: 4, text: 'Below average' },
            { value: 5, text: 'So-so' },
            { value: 6, text: 'Above average' },
            { value: 7, text: 'Most of the time' },
            { value: 7, text: 'Most of the time' },
            { value: 9, text: 'Yes, definitely' },
            { value: 10, text: 'Yes, definitely' },
        ],
        label: OCCUPATION,
        colour: OCCUPATION,
    },

    {
        question: { id: 5, text: QUESTIONS.STRESS },
        answersLabel: [
            { value: 0, text: 'Not at all' },
            { value: 1, text: 'Not at all' },
            { value: 2, text: 'Not really' },
            { value: 3, text: 'Not really' },
            { value: 4, text: 'Below average' },
            { value: 5, text: 'So-so' },
            { value: 6, text: 'Above average' },
            { value: 7, text: 'Most of the time' },
            { value: 7, text: 'Most of the time' },
            { value: 9, text: 'Yes, definitely' },
            { value: 10, text: 'Yes, definitely' },
        ],
        label: STRESS,
        colour: STRESS,
    },
    {
        question: { id: 6, text: QUESTIONS.SATISFACTION },
        answersLabel: [
            { value: 0, text: 'Not at all' },
            { value: 1, text: 'Not at all' },
            { value: 2, text: 'Not really' },
            { value: 3, text: 'Not really' },
            { value: 4, text: 'Below average' },
            { value: 5, text: 'So-so' },
            { value: 6, text: 'Above average' },
            { value: 7, text: 'Most of the time' },
            { value: 7, text: 'Most of the time' },
            { value: 9, text: 'Yes, definitely' },
            { value: 10, text: 'Yes, definitely' },
        ],
        label: RESOURCEdb.WELLBEINGATWORK.SATISFACTION,
        mainQuestion: true,
    },
    {
        question: { id: 7, text: QUESTIONS.POSITIVE[pilotTag] || QUESTIONS.POSITIVE.default },
        answersLabel: [
            { value: 0, text: 'Not at all' },
            { value: 1, text: 'Not at all' },
            { value: 2, text: 'Not really' },
            { value: 3, text: 'Not really' },
            { value: 4, text: 'Below average' },
            { value: 5, text: 'So-so' },
            { value: 6, text: 'Above average' },
            { value: 7, text: 'Most of the time' },
            { value: 7, text: 'Most of the time' },
            { value: 9, text: 'Yes, definitely' },
            { value: 10, text: 'Yes, definitely' },
        ],
        label: RESOURCEdb.WELLBEINGATWORK.POSITIVE,
        mainQuestion: true,
    },
]

const assessment = {
    version: '1.5',
    date: '21 Mar 2022',
    index: '-1',
}

export default assessment
